// reportWebVitals.js is disabled for this project.
// No-op for custom website.

const reportWebVitals = () => {};
export default reportWebVitals;
